const AUTH_FLOWS = {
  SIGN_IN: 'SIGN_IN',
  FROM_JWT: 'FROM_JWT'
};

export default AUTH_FLOWS;
